// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2lUvS","inputWrap":"styles_inputWrap__BFFd9","input":"styles_input__1srYr"};